import ItemList, {
  getServerSideProps as itemServerProps,
} from "../../item/[id]/[slug]";

export async function getServerSideProps(props: any) {
  return itemServerProps(props);
}
export default ItemList;
